import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Letters.css';

/*
 * ==============================================
 * HOW TO EDIT (via Claude chat):
 * ==============================================
 * "Add a letter from Mom with this text: ..."
 * "Add a letter from my friend John dated 2015"
 * "Add a letter image from /images/letters/..."
 */

const letters = [
  // === ADD LETTERS BELOW ===
  // {
  //   id: 1,
  //   from: 'Mom',
  //   date: 'Date',
  //   preview: 'First few words of the letter...',
  //   content: 'The full letter text goes here...',
  //   image: null, // or '/images/letters/mom-letter1.jpg' for scanned letters
  // },
  // === ADD LETTERS ABOVE ===
];

function Letters() {
  const [openLetter, setOpenLetter] = useState(null);

  return (
    <section className="letters section-padding" id="letters">
      <div className="container">
        <motion.div
          className="letters__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">Letters</span>
          <h2 className="section-title">
            Words from the heart<br />
            <span className="text-gradient">from people I love</span>
          </h2>
          <p className="letters__subtitle">
            Letters from Mom and from people close to me, preserved forever.
          </p>
        </motion.div>

        {letters.length > 0 ? (
          <div className="letters__grid">
            {letters.map((letter, i) => (
              <motion.div
                key={letter.id}
                className="letters__card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * i }}
                whileHover={{ y: -4, transition: { duration: 0.3 } }}
                onClick={() => setOpenLetter(openLetter === letter.id ? null : letter.id)}
              >
                <div className="letters__card-envelope">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <div className="letters__card-meta">
                  <span className="letters__card-from">From: {letter.from}</span>
                  <span className="letters__card-date">{letter.date}</span>
                </div>
                <p className="letters__card-preview">{letter.preview}</p>

                <AnimatePresence>
                  {openLetter === letter.id && (
                    <motion.div
                      className="letters__card-full"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      {letter.image && (
                        <div className="letters__card-image">
                          <img src={letter.image} alt={`Letter from ${letter.from}`} />
                        </div>
                      )}
                      <p className="letters__card-content">{letter.content}</p>
                    </motion.div>
                  )}
                </AnimatePresence>

                <span className="letters__card-toggle">
                  {openLetter === letter.id ? 'Close' : 'Read letter'}
                </span>
              </motion.div>
            ))}
          </div>
        ) : (
          <motion.div
            className="letters__empty"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="letters__empty-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </div>
            <h3>No letters yet</h3>
            <p>Tell Claude to add letters from your Mom and loved ones here.</p>
          </motion.div>
        )}
      </div>
    </section>
  );
}

export default Letters;
